import { UrlParam } from '@/lib/url/url-param.hook'

import { BaseHorizontalTabs, BaseHorizontalTabsProps } from './base-horizontal'
import { useHorizontalTabsUrl } from './use-horizontal-tabs-url.hook'

export type HorizontalTabsProps = Omit<
  BaseHorizontalTabsProps,
  'value' | 'defaultValue' | 'onChange'
> & {
  urlParamKey?: UrlParam
  defaultValue?: string
  onChange?: (tab: string) => void
  shouldCheckUnsavedChanges?: boolean
}

export const HorizontalTabs = ({
  urlParamKey,
  defaultValue,
  onChange,
  shouldCheckUnsavedChanges = false,
  ...props
}: HorizontalTabsProps) => {
  const urlSyncProps = useHorizontalTabsUrl({
    urlParamKey,
    items: props.items,
    defaultValue,
    shouldCheckUnsavedChanges,
    onChange,
  })

  return <BaseHorizontalTabs {...props} {...urlSyncProps} />
}
